const data=[
    {
        imgSrc:"https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/Certificates%2FSQL_Certification.jpg?alt=media&token=8a9783e3-aa31-4498-baa9-cc51b896bd4b",
        certificateLink:"https://catalog-education.oracle.com/pls/certview/sharebadge?id=662E6306692F0C827E083FD42727F00C8CE174D1E9F2B55281943F1C026460CE"
    },
    {
        imgSrc:"https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/Certificates%2FOIC_IntegrationCloud.jpg?alt=media&token=f00d07a8-fefa-48ec-8afe-553f87416ee2",
        certificateLink:"https://catalog-education.oracle.com/pls/certview/sharebadge?id=21B5C26D06D37978754F5DE76931123285C1331D81694FFE1E2F87411BDF4702"
    },
    {
        imgSrc:"https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/Certificates%2FOCIFoundationCertificate.jpg?alt=media&token=b675f364-942b-4617-9971-f123e85ba622",
        certificateLink:"https://catalog-education.oracle.com/pls/certview/sharebadge?id=73E9AB0D9E772933B43679303A5C9CE3A37FE6C64131C1E29DD06661DDF70DFB"
    },
    {
        imgSrc:"https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/Certificates%2FPersonalBrandingCoursera.jpg?alt=media&token=a841fd00-0ec6-4148-8f3f-c33e942157dc",
        certificateLink:"https://www.coursera.org/account/accomplishments/verify/B5VL3L3MPQG4",
    },
    {
        imgSrc:"https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/Certificates%2FGettingStartedWithPythonCoursera.jpg?alt=media&token=feb3bff6-b476-4a0e-84c3-ae4ab5dd85f6",
        certificateLink:"https://www.coursera.org/account/accomplishments/verify/5NP27732PK8F",
    },
    {
        imgSrc:"https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/Certificates%2FCourseraStanfordMLcertificate.jpg?alt=media&token=be82fad1-4d3c-4ad0-85a1-e2008508eb8c",
        certificateLink:"https://www.coursera.org/account/accomplishments/verify/7T893X6H5DL8",
    },
    {
        imgSrc:"https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/Certificates%2FPythonCognitiveCertificate.png?alt=media&token=235d1917-7e1a-4b4d-949c-210e6e90c06c",
        certificateLink:"https://courses.cognitiveclass.ai/certificates/63b9cd7ea64d48ff861829cf2df88af4",
    },
    {
        imgSrc:"https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/Certificates%2FMicrosoftCertificate_AI.jpg?alt=media&token=35e5fa15-6673-42f3-9188-a0a35a217680",
        certificateLink:""
    }

]

export default data;